<template>
    <ui-report title="Payment Certificates Due" subtitle="A list of AFPs that do not have payment certificates yet or that have not been certified with the correct amounts." no-filters v-slot="{ filters }">
        <ui-report-panel :filters="filters" :fetch="fetch" @filtersChanged="({ refresh }) => refresh()" v-slot="{ report }" class="overflow-hidden">
            <ui-table v-if="report && report.length > 0" :headers="['Package', 'Due In', 'Latest Application', 'Latest Certificate', 'Difference']" v-slot="{ cellClass }">
                <template v-for="pcGroup in report">
                    <tr :key="pcGroup.key">
                        <td colspan="7" v-text="pcGroup.label" class="px-6 py-2 border-b border-t bg-gray-50 text-gray-500 font-semibold text-xs uppercase tracking-widest"></td>
                    </tr>
                    <tr v-for="pc in pcGroup.pcs" :key="pc.key()" class="hover:bg-blue-50 cursor-pointer" @click="goTo(pc._links.frontend.view)">
                        <td :class="cellClass" class="max-w-sm truncate align-top" :title="pc.package_name" v-text="pc.package_name"></td>
                        <td :class="[cellClass, pc.due_in_class]" class="align-top" v-text="pc.due_in"></td>
                        <td :class="cellClass" class="align-top">
                          <div class="font-bold">{{ pc.latest_afp_date_formatted }}</div>
                          <div class="text-sm">{{ pc.latest_afp_value | toCurrency }}</div>
                        </td>
                        <td :class="cellClass" class="align-top">
                          <div class="font-bold">{{ pc.latest_payment_certificate_due_date_formatted }}</div>
                          <div class="text-sm">{{ pc.latest_payment_certificate_value | toCurrency }}</div>
                        </td>
                        <td :class="cellClass" class="text-right align-top">{{ pc.afp_and_payment_certificate_difference | toCurrency }}</td>
                    </tr>
                </template>
            </ui-table>
            <div v-else class="px-4 py-16 text-center text-gray-400">
                There has been no activity in accidents within the provided filters...
            </div>
        </ui-report-panel>
    </ui-report>
</template>

<script>
import { groupBy, map, sortBy } from 'lodash'
import { PaymentCertificate } from '@models'
import { parseMoment } from '@utils'

export default {
    methods: {
        async fetch () {
            let pcs = await PaymentCertificate.all()
            pcs = pcs.map(pc => this.parsePC(pc))
            pcs = groupBy(pcs, pc => pc.due_group_key)
            pcs = map(pcs, (pcs, key) => ({
                key,
                pcs: sortBy(pcs, pc => pc.diff_days),
                label: pcs[0].due_group_label
            }))
            return pcs
        },
        parsePC (pc) {
            const dueDate = parseMoment(pc.latest_payment_certificate_due_date, 'YYYY-MM-DD')
            pc.diff_days = dueDate.diff(new Date(), 'days')
            pc.due_in = pc.diff_days + ' ' + (Math.abs(pc.diff_days) === 1 ? 'day' : 'days')
            pc.due_in = pc.diff_days === 0 ? 'today' : pc.due_in
            pc.due_in_class = pc.diff_days < 0 ? 'text-red-600' : 'text-green-600'
            const group = this.getPcGroup(pc.diff_days)
            pc.due_group_key = group.key
            pc.due_group_label = group.label

            pc.latest_afp_date_formatted = parseMoment(pc.latest_afp_date, 'YYYY-MM-DD').format('DD/MM/YYYY')
            pc.latest_payment_certificate_due_date_formatted = parseMoment(pc.latest_payment_certificate_due_date, 'YYYY-MM-DD').format('DD/MM/YYYY')
            return pc
        },
        getPcGroup (diffDays) {
            if (diffDays < 0) return { key: '1_overdue', label: 'Overdue' }
            if (diffDays < 1) return { key: '2_today', label: 'Today' }
            if (diffDays < 15) return { key: '3_1_to_14_days', label: 'Due In 1 - 14 Days' }
            if (diffDays < 31) return { key: '4_14_to_30_days', label: 'Due In 14 - 30 Days' }
            return { key: '5_30_days_plus', label: 'Due 30 Days +' }
        },
        goTo (url) {
            window.location = url
        },
    }
}
</script>
